// Function loadFindGiftRegistryPage loads the FindGiftRegistryPage class by dynamically importing the js on demand if needed

export function loadFindGiftRegistryPage() {

	let $pg = document.querySelector('[data-pg="FindGiftRegistryPage"]');

	if (!$pg) {
		// console.info('FindGiftRegistryPage: no widget found');
		return Promise.reject('FindGiftRegistryPage page not found in the parent element');
	}

	return import(/* webpackChunkName: "pg-find-gift-registry-page-chunk" */ './findGiftRegistryPage').then(pg => {

		const { FindGiftRegistryPage } = pg;

		return new FindGiftRegistryPage($pg);


	}).catch(error => error+'An error occurred while loading the FindGiftRegistryPage page');

}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/390/s/FrontEnd/src/views/pages/findGiftRegistryPage/js/loadPg.js